export const CONTROL_PANEL_NAMESPACE = 'controlPanel'
export const CONTROL_PANEL_TOGGLE = 'controlPanelToggle'
export const CONTROL_PANEL_IS_OPEN = 'isControlPanelOpen'
export const CONTROL_PANEL_CLOSE = 'panelClose'
